
import { PropType } from "vue";
import { Options, prop, Vue } from "vue-class-component";
import TimeSlotChip from "./TimeSlotChip.vue";
import PickupTimePopover from "./PickupTimePopover.vue";
import { RegularTimeSlot } from "./schedule-types";
import { addOneHour } from "./schedule-utils";

class SpecialDateRowProps {
  date = prop<string>({ required: true, type: String });
  dateLabel = prop<string>({ required: true, type: String });
  slots = prop<RegularTimeSlot[]>({
    default: () => [],
    type: Array as PropType<RegularTimeSlot[]>
  });
  maxSlots = prop<number>({ default: 3, type: Number });
  disabled = prop<boolean>({ default: false, type: Boolean });
  slotStartHour = prop<number>({ default: 8, type: Number });
  slotEndHour = prop<number>({ default: 23, type: Number });
  slotIntervalMinutes = prop<number>({ default: 60, type: Number });
}

@Options({
  components: {
    TimeSlotChip,
    PickupTimePopover
  }
})
export default class SpecialDateRow extends Vue.with(SpecialDateRowProps) {
  isPopoverOpen = false;

  get isMaxSlots(): boolean {
    return this.slots.length >= this.maxSlots;
  }

  get sortedSlots(): RegularTimeSlot[] {
    return [...this.slots].sort((a, b) => a.start.localeCompare(b.start));
  }

  togglePopover(): void {
    if (this.isMaxSlots || this.disabled) return;
    this.isPopoverOpen = !this.isPopoverOpen;
  }

  onRemoveSlot(slotToRemove: RegularTimeSlot): void {
    const updated = this.slots.filter((s) => s.start !== slotToRemove.start);
    this.$emit("update:slots", updated);
  }

  onAddSlotConfirm(start: string): void {
    const end = addOneHour(start);
    const updated = [...this.slots, { start, end }].sort((a, b) =>
      a.start.localeCompare(b.start)
    );

    this.$emit("update:slots", updated);
  }
}
